export class BODiagnosticNovo{
    id:number;
    tempId?:string;
    patientId:number;
    clinicHistoryId:number;
    cie10Code?            :string;
    cie10Name?            :string;
    cie11Code?            :string;
    cie11Name?            :string;
    orphanDiseaseCode?    :string;
    orphanDiseaseName?    :string;
    diseaseType?          :number; //Enfermedad Común: 1; Enfermedad Huérfana: 2
    diagnosticType?       :number;//Impresion diag, nuevo, repetido
    diagnosticCategory?   :number; //Principal: 1 Related:2
    details?              :string;
}
